import React, { useState } from "react";

import { Minus } from "../../../../components/svg/svgImageList";
import Button from "../../../../components/button/Button";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useThemeService from "../../../../services/theme-service/ThemeService";
import { TranslationContext } from "../../../../services/translation/TranslationService";
import useModal from "../../../../components/dialog/useModal";
import { UsersStorage } from "../../../../services/user/UsersStorage";

interface StopCollaborationButtonProps {
  disabled?: boolean;
  confirmationModalTitleKey: string;
  confirmationModalTitleContext?: TranslationContext;
  confirmationModalSubtitleKey: string;
  confirmationAction: () => void;
  optionalWarningKey?: string;
  optionalWarningContext?: TranslationContext;
  fetchLockedInspectionsCountOnDemand?: boolean;
  usersStorage?: UsersStorage;
}

export default function StopCollaborationButton(props: StopCollaborationButtonProps) {
  const { themeClass } = useThemeService();
  const { toggleModal, isVisible } = useModal();

  const {
    disabled,
    confirmationAction,
    confirmationModalTitleKey,
    confirmationModalTitleContext,
    confirmationModalSubtitleKey,
    optionalWarningContext,
    optionalWarningKey,
    fetchLockedInspectionsCountOnDemand,
    usersStorage,
  } = props;

  const [localOptionalWarningKey, setLocalOptionalWarningKey] = useState("");
  const [localOptionalWarningContext, setLocalOptionalWarningContext] = useState({ count: 0 });

  const handleConfirmationAction = () => {
    confirmationAction();
    toggleModal();
  };

  const onStopCollaboration = async () => {
    if (fetchLockedInspectionsCountOnDemand) {
      const lockedInspectionsCount = await usersStorage?.getLockedInspectionsCountForUsers(
        usersStorage.selectedItems
      );
      if (lockedInspectionsCount > 0) {
        setLocalOptionalWarningKey(
          lockedInspectionsCount > 1
            ? "UsersPage.remove.locked-inspections"
            : "UsersPage.remove.locked-inspection"
        );
      } else {
        setLocalOptionalWarningKey("");
      }

      setLocalOptionalWarningContext({ count: lockedInspectionsCount });
    }
    toggleModal();
  };

  return (
    <>
      <Button
        id="stop-collaboration"
        disabled={disabled}
        onClick={onStopCollaboration}
        icon={{
          svg: Minus,
          textKey: "general.users.stop-collaboration",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-stop-collaboration"]),
        }}
      />
      <WarningBeforeAction
        isVisible={isVisible}
        titleKey={confirmationModalTitleKey}
        titleContext={confirmationModalTitleContext}
        subtitleKey={confirmationModalSubtitleKey}
        optionalWarningKey={localOptionalWarningKey ? localOptionalWarningKey : optionalWarningKey}
        optionalWarningContext={
          localOptionalWarningContext.count > 0
            ? localOptionalWarningContext
            : optionalWarningContext
        }
        buttonOk={{
          id: "stop-collaboration-ok",
          textKey: "general.users.stop-collaboration",
          action: handleConfirmationAction,
        }}
        toggleModal={toggleModal}
      />
    </>
  );
}
